/**
 * Firebase Configuration
 * Uses environment variables for Firebase service account configuration
 */

import { initializeApp } from 'firebase/app';
import { getAuth, signInWithEmailAndPassword, signOut, updatePassword, updateProfile as firebaseUpdateProfile } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration from environment variables
const firebaseConfig = {
  projectId: process.env.REACT_APP_PROJECT_ID,
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: `${process.env.REACT_APP_AUTH_DOMAIN}.firebaseapp.com`,
  databaseURL: `https://looks-f1244-default-rtdb.firebaseio.com/`,
  storageBucket: `${process.env.REACT_APP_STORAGE_BUCKET}.appspot.com`,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export { app };
export const auth = getAuth(app);
export const db = getFirestore(app);

// Firebase authentication functions
export const firebaseAuth = {
  signIn: async (email: string, password: string) => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const token = await userCredential.user.getIdToken();
      return {
        user: {
          id: userCredential.user.uid,
          email: userCredential.user.email || '',
          name: userCredential.user.displayName || 'Admin',
          role: 'admin',
        },
        token,
      };
    } catch (error) {
      throw new Error('Invalid email or password');
    }
  },

  signOut: async () => {
    await signOut(auth);
  },

  updatePassword: async (currentPassword: string, newPassword: string) => {
    const user = auth.currentUser;
    if (!user || !user.email) {
      throw new Error('No authenticated user found');
    }

    // Re-authenticate user before password change
    try {
      await signInWithEmailAndPassword(auth, user.email, currentPassword);
      await updatePassword(user, newPassword);
    } catch (error) {
      throw new Error('Current password is incorrect');
    }
  },

  updateProfile: async (user: any, data: { displayName?: string }) => {
    await firebaseUpdateProfile(user, data);
  },

  getCurrentUser: () => {
    return auth.currentUser;
  },
};

export default app;
